var $cfbacb6e0b68a488$exports = {};
const $cfbacb6e0b68a488$var$testimontialSlides = document.querySelectorAll(".c-quote__right");
const $cfbacb6e0b68a488$var$changeBtn = document.querySelector(".testimontial-slide-changer");
let $cfbacb6e0b68a488$var$slideCounter = 0;
$cfbacb6e0b68a488$var$changeTestimontalSlide();
$cfbacb6e0b68a488$var$changeBtn.addEventListener("click", ()=>{
    if ($cfbacb6e0b68a488$var$slideCounter + 1 == $cfbacb6e0b68a488$var$testimontialSlides.length) $cfbacb6e0b68a488$var$slideCounter = 0;
    else $cfbacb6e0b68a488$var$slideCounter++;
    $cfbacb6e0b68a488$var$changeTestimontalSlide();
});
function $cfbacb6e0b68a488$var$changeTestimontalSlide() {
    $cfbacb6e0b68a488$var$testimontialSlides.forEach((el)=>{
        el.classList.add("hidden");
    });
    $cfbacb6e0b68a488$var$testimontialSlides[$cfbacb6e0b68a488$var$slideCounter].classList.remove("hidden");
}


//# sourceMappingURL=join-us.12da90fc.js.map
